import React, {useState} from 'react';
import style from './Search.module.css';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {withRouter} from "react-router-dom";
import icon from './../../../assets/images/main.png'
import {searchUrl} from "../../Search/Search";

export const SECTIONS = [
    {value: 'articles', label: 'по статьям'},
    {value: 'books', label: 'по учебным изданиям'},
];

const Search = ({history}) => {
    const [query, setQuery] = useState('');
    const [sect, setSect] = useState('articles');
    const [hint, setHint] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        const q = query.trim();
        if (!q) {
            setHint(true);
            return;
        }
        history.push(searchUrl(q, sect));
    };

    return (
        <div className={style.search}>
            <Container>
                <Row>
                    <div className={style.searchRow}>
                        <div className={style.searchTitle}>
                            <img className={style.image} src={icon} alt=""/> <span className={style.library}>Library</span>
                        </div>
                        <form className={style.form} onSubmit={onSubmit} role="search">
                            <div className={style.area}>
                                <div className={style.button}>
                                    <button type="submit"><span className={style.icon}>Искать</span></button>
                                </div>
                                <div className={style.input}>
                                    <input
                                        type="search"
                                        name="q"
                                        value={query}
                                        onChange={(e) => {
                                            setQuery(e.target.value);
                                            if (hint) setHint(false);
                                        }}
                                        placeholder="Поиск по названию"
                                        aria-label="Поиск по названию"
                                    />
                                </div>
                            </div>
                            {hint ? <div className={style.hint}>Введите название или его часть</div> : null}
                            <div className="mt-2 p-0 text-md-left text-center">
                                {SECTIONS.map((s, i) => (
                                    <label key={s.value} className={i ? 'ml-3' : undefined}>
                                        <input
                                            type="radio"
                                            name="sect"
                                            value={s.value}
                                            checked={sect === s.value}
                                            onChange={() => setSect(s.value)}
                                        />
                                        <span> {s.label}</span>
                                    </label>
                                ))}
                            </div>
                        </form>
                    </div>
                </Row>
            </Container>
        </div>
    )
}

export default withRouter(Search);
